module.exports = global["application_page_instructionElement"] = require("-!/app/node_modules/ts-loader/index.js??ref--4!./instruction-element.ts");